import { CEProcessBase } from './ce-process-base'


export class CEProcess extends CEProcessBase {

}